import React from 'react';

import Form from './Form';

const SignIn: React.FC = (): JSX.Element => <Form />;

export default SignIn;
